export default "/images/lokal.webp?05dc70e20708c8bded548c5309608b15";